module.exports = __webpack_public_path__ + "img/leafy_tree_white.2d5406a2.svg";